export default "__VITE_ASSET__DxBlHBtt__"